import React from 'react';

import {
  DialogContext,
  DialogContextValues
} from '@smart-tv/contexts/dialog-context/dialog-context';

export const useDialog = (): DialogContextValues => {
  const values = React.useContext(DialogContext);

  return { ...values };
};

export default useDialog;
